import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20a8c308"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "company-card-footer" }

import { useRouter } from "vue-router";

import Btn from "@/components/common/Btn.vue";

interface IProps {
  updateAccount: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyCardFooter',
  props: {
    updateAccount: { type: Function }
  },
  setup(__props: any) {



const router = useRouter();
const goBack = () => {
  router.go(-1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(Btn, {
      class: "action-btn",
      "btn-type": "btn-gray",
      "on-click-event": goBack
    }, {
      default: _withCtx(() => [
        _createTextVNode(" キャンセル ")
      ]),
      _: 1
    }),
    _createVNode(Btn, {
      class: "action-btn",
      "btn-type": "btn-primary",
      "on-click-event": _ctx.updateAccount
    }, {
      default: _withCtx(() => [
        _createTextVNode(" 保存 ")
      ]),
      _: 1
    }, 8, ["on-click-event"])
  ]))
}
}

})